import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Portal from "@/pages/Portal";
import Dashboard from "@/pages/Dashboard";
import Courses from "@/pages/Courses";
import Quizzes from "@/pages/Quizzes";
import Plans from "@/pages/Plans";
import Resources from "@/pages/Resources";
import Appointments from "@/pages/Appointments";
import Invoices from "@/pages/Invoices";
import Clients from "@/pages/Clients";
import Settings from "@/pages/Settings";
import SsoSetup from "@/pages/SsoSetup";
import ImportCenter from "@/pages/ImportCenter";
import PortalExtras from "@/pages/PortalExtras";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-ivory">
      <div className="h-10 w-10 rounded-full border-4 border-gold-200 border-t-gold-500 animate-spin" />
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

// Subdomains that should serve ONLY the client portal (admin hidden).
const PORTAL_HOSTS = ["my.resiliencecommunitycollective.com.au"];
const isPortalHost = PORTAL_HOSTS.includes((window.location.hostname || "").toLowerCase());

function AppRoutes() {
  if (isPortalHost) {
    // Portal-only domain: every path renders the client portal; no admin routes exist here.
    return (
      <Routes>
        <Route path="*" element={<Portal />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/portal" element={<Portal />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/quizzes" element={<Quizzes />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/portal-content" element={<PortalExtras />} />
        <Route path="/appointments" element={<Appointments />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/import" element={<ImportCenter />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/sso-setup" element={<SsoSetup />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
